export const AdjustmentSubTypePolicy = ({

    SAME_LINE : "RBSL",
    DIFF_LINE : "RBDL"

})